import React, { useContext } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Dialog, DialogContent, DialogActions, Button, Box, Typography, IconButton } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { TenantsContext } from '../../context/tenants.context'
import useLocal from '../../pages/Products/hooks/locals.hook'

interface DialogContactoSoporteProps {
  open: boolean
  codLocal: string
  setCode?: (c: string) => void
  closable?: boolean
  onClose?: () => void
  onContactar?: () => void
}

const DialogContactoSoporte: React.FC<DialogContactoSoporteProps> = ({
  open,
  codLocal,
  setCode,
  closable = false,
  onClose,
  onContactar
}) => {
  const { tenant } = useContext(TenantsContext)
  const { whppSoporte } = useLocal(codLocal)

  const handleContactar = () => {
    const mensaje = `Hola, me acabo de registrar en ${tenant.nombrePlataforma}`
    if (!whppSoporte) return
    window.open(`https://wa.me/${whppSoporte}?text=${encodeURIComponent(mensaje)}`, '_blank')
    onContactar?.()
    setCode && setCode(null)
    if (closable) onClose?.()
  }

  return (
    <Dialog
      open={open}
      onClose={closable ? onClose : undefined}
      disableEscapeKeyDown={!closable}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { overflowX: 'hidden' } }}
    >
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', pt: 2 }}>
          <WhatsAppIcon sx={{ fontSize: 80, color: '#25D366', mb: 2 }} />
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
            Tu cuenta está pendiente de aprobación
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Para poder continuar con el proceso de registración necesitamos que nos escribas por WhatsApp.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        {closable && (
          <IconButton
            edge="end"
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '0',
              right: '0',
              paddingRight: '16px'
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
        <Button
          variant="contained"
          color="success"
          fullWidth
          startIcon={<WhatsAppIcon />}
          onClick={handleContactar}
          sx={{
            background: 'linear-gradient(45deg, #55CF60, #27B53F)',
            color: '#fff',
            borderRadius: '5px'
          }}
        >
          Contactar por WhatsApp
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogContactoSoporte
